/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/CompanyStatuses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Status Reducers 
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    COMPANYSTATUS_LIST_CONTAINER_LOADED,
    COMPANYSTATUS_LIST_CONTAINER_UNLOADED,
    COMPANYSTATUS_LIST_TABLE_LOADED,
    COMPANYSTATUS_LIST_TABLE_UNLOADED,
    COMPANYSTATUS_SELECT_ROW,
    COMPANYSTATUS_ADD,
    COMPANYSTATUS_EDIT,
    COMPANYSTATUS_DELETE,
    COMPANYSTATUS_OPEN_WARNING,
    COMPANYSTATUS_CLOSE_WARNING,
    COMPANYSTATUS_EDIT_CONTAINER_LOADED,
    COMPANYSTATUS_EDIT_CONTAINER_UNLOADED,
    COMPANYSTATUS_EDIT_FORM_LOADED,
    COMPANYSTATUS_EDIT_FORM_UNLOADED,
    COMPANYSTATUS_EDIT_DATA_LOAD,
    COMPANYSTATUS_EDIT_CONTAINER_SUBMIT,
    COMPANYSTATUS_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeCompanyStatuses';

const defaultState = {
    refreshList: false,
    companystatuses: [],
    danger: false,
    companystatusid: 0,
    name: '',
    description: '',
    color: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case COMPANYSTATUS_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                companystatuses: action.payload ? action.payload.companystatuses : []
            }
        case COMPANYSTATUS_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case COMPANYSTATUS_SELECT_ROW:
            return {
                ...state,
                companystatusid: action.id
            }
        case COMPANYSTATUS_ADD:
            return {
                ...state
            }
        case COMPANYSTATUS_EDIT:
            return {
                ...state,
                companystatusid: action.id
            }
        case COMPANYSTATUS_DELETE:
            return {
                ...state,
                companystatusid: null
            }
        case COMPANYSTATUS_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case COMPANYSTATUS_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case COMPANYSTATUS_EDIT_CONTAINER_LOADED:
        case COMPANYSTATUS_EDIT_DATA_LOAD:
            return {
                ...state,
                companystatusid: action.payload ? action.payload.companystatusid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                color: action.payload ? action.payload.color : '',
                orderid: action.payload ? action.payload.orderid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case COMPANYSTATUS_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case COMPANYSTATUS_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case COMPANYSTATUS_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case COMPANYSTATUS_LIST_CONTAINER_UNLOADED:
        case COMPANYSTATUS_LIST_TABLE_UNLOADED:
        case COMPANYSTATUS_EDIT_CONTAINER_UNLOADED:
        case COMPANYSTATUS_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/CompanyStatuses.js